module.exports = __webpack_public_path__ + "bc18f93b915d2c61b0d4a97b4f48acee.pdf";